import { motion } from "motion/react";

export function TrustMetrics() {
  const metrics = [
    { value: "8+", label: "Years Experience" },
    { value: "20+", label: "Happy Clients" },
    { value: "150+", label: "Projects Delivered" },
    { value: "25Cr+", label: "Revenue Boosted" },
  ];

  return (
    <div className="bg-[#FD5750] py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center divide-x divide-white/20">
          {metrics.map((metric, index) => (
            <div key={index} className="px-4">
              <motion.div
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="text-4xl md:text-5xl font-bold text-white mb-2"
              >
                {metric.value}
              </motion.div>
              <div className="text-white/80 font-medium text-sm md:text-base">{metric.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
